import React, { useCallback } from 'react';
import { Loader } from '@ui';
import { Checkbox } from '@ui/molecules/inputs/Checkbox';
import { translate } from '@utils/i18n';
import useAIInspectionManager from '../../hooks/useAIInspectionManager';
import useUpdateAIInspectionManager from '../../hooks/useUpdateAIInspectionManager';
import TermsManagement from './TermsManagement';
import './GrammarAndStyleTabStyles.scss';
const namespace = 'features.settings.ai_inspection_manager.grammar_and_style';
function GrammarAndStyleTab() {
    var _a, _b, _c;
    const { data: settings, isLoading } = useAIInspectionManager();
    const { updateSettings } = useUpdateAIInspectionManager();
    const apiSettings = settings === null || settings === void 0 ? void 0 : settings.aiInspectionManagerGrammarAndStyleAdvancedSettings;
    const advancedSettings = {
        includeInHighImpactIssues: (_a = apiSettings === null || apiSettings === void 0 ? void 0 : apiSettings.includeInHighImpactIssues) !== null && _a !== void 0 ? _a : false,
        excludedTerms: (_b = apiSettings === null || apiSettings === void 0 ? void 0 : apiSettings.excludedTerms) !== null && _b !== void 0 ? _b : [],
        includedTerms: (_c = apiSettings === null || apiSettings === void 0 ? void 0 : apiSettings.includedTerms) !== null && _c !== void 0 ? _c : []
    };
    const handleCheckboxChange = useCallback((checked) => {
        const updatedSettings = Object.assign(Object.assign({}, advancedSettings), { includeInHighImpactIssues: checked });
        updateSettings.mutate({
            settingsUpdate: {
                aiInspectionManagerGrammarAndStyleAdvancedSettings: updatedSettings
            }
        });
    }, [advancedSettings, updateSettings]);
    const handleUpdateSettings = useCallback((updatedSettings) => {
        updateSettings.mutate({
            settingsUpdate: {
                aiInspectionManagerGrammarAndStyleAdvancedSettings: updatedSettings
            }
        });
    }, [updateSettings]);
    if (isLoading) {
        return (React.createElement("div", { className: "grammar-and-style-tab" },
            React.createElement("div", { style: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' } },
                React.createElement(Loader, { size: "48", title: "Loading", vertical: true }))));
    }
    return (React.createElement("div", { className: "grammar-and-style-tab main-section-container" },
        React.createElement("div", { className: "advanced-settings-section" },
            React.createElement("h3", { className: "advanced-settings-section__title" },
                translate('section_title', { namespace }),
                React.createElement("div", { className: "advanced-settings-section__title-line" })),
            React.createElement("div", { className: "advanced-settings-section__checkbox" },
                React.createElement(Checkbox, { id: "include-high-impact", label: translate('include_in_high_impact', { namespace }), checked: advancedSettings.includeInHighImpactIssues, onChange: (checked) => handleCheckboxChange(checked) })),
            React.createElement("div", { className: "grammar-and-style-tab__tabs" },
                React.createElement(TermsManagement, { advancedSettings: advancedSettings, onUpdateSettings: handleUpdateSettings })))));
}
export default GrammarAndStyleTab;
